<template>
  <b-row class="validation-form-skeleton">
    <b-col
      v-for="(width, index) in skeletonWidths"
      :key="index"
      :cols="index % 2 === 0 ? 4 : 8"
      :class="{ 'mt-2': index % 6 === 0 && index !== 0 }"
      class="custom-spacing"
    >
      <b-skeleton animation="wave" :width="width"></b-skeleton>
    </b-col>
  </b-row>
</template>

<script>
export default {
  data() {
    return {
      skeletonCount: 30,
      skeletonWidths: [],
    };
  },
  methods: {
    getRandomWidth(min = 60, max = 90) {
      return `${Math.floor(Math.random() * (max - min + 1)) + min}%`;
    },
    generateSkeletonWidths() {
      this.skeletonWidths = Array.from({ length: this.skeletonCount }, () =>
        this.getRandomWidth()
      );
    },
  },
  created() {
    this.generateSkeletonWidths();
  },
};
</script>

<style lang="scss" >
.validation-form-skeleton {
  .custom-spacing {
    margin-bottom: 1.25rem;
  }
}

@media (min-width: 576px) {
  .validation-form-skeleton {
    padding: 1rem 5rem !important;
  }
}

@media (min-width: 1200px) {
  .validation-form-skeleton {
    padding: 1rem 15rem !important;
  }
}
</style>